import React from 'react';
import PropTypes from 'prop-types';
import userManager from '../../utils/userManager';
import { connect } from 'react-redux';

class LoginPage extends React.Component {
  componentDidMount() {
    const { history, location } = this.props;
    let from = location.from ? `${location.from.pathname}${location.from.search}` : '/';

    userManager
      .signinSilent()
      .then(() => {
        history.push(from);
      })
      .catch(() => {
        //if (err.message === "login_required") {
        userManager.signinRedirect({
          data: { redirectUrl: from }
        });
        //}
      });
  }

  render() {
    return <div>Signing in</div>;
  }
}

LoginPage.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object
};

export default connect()(LoginPage);
